import Emitter from "es6-event-emitter";

import publicationList from "./../templates/publicationList.dust";

/**
 * Contstructs the Kiosque view
 */
export default class PublicationList extends Emitter {
  constructor(
    appState,
    DOMContent,
    name,
    titleName,
    contentPackages,
    clickedEvent,
    options
  ) {
    super();
    this.appState = appState;
    this.DOMContent = DOMContent;
    this.name = name;
    this.titleName = titleName;
    this.contentPackages = contentPackages;
    this.clickedEvent = clickedEvent;
    this.options = options;
  }

  createContext() {
    const context = {};
    context.contentPackages = this.contentPackages;
    context.name = this.name;
    context.titleName = this.titleName;
    return context;
  }

  render() {
    if (this.DOMContent) {
      if (this.contentPackages.length === 0) {
        return;
      }
      const container = this.DOMContent.querySelector(`#${this.name}`);
      if (container) {
        Dust.render(publicationList, this.createContext(), (err, result) => {
          container.innerHTML = result;
          $(container).on("click", ".thumb-wrapper", (e) => {
            this.trigger("publicationList:onPublicationClicked", e);
            this.appState.triggerEvent(this.clickedEvent);
          });
        });
      }
    } else {
      setTimeout(() => {
        this.render();
      }, 100);
    }
  }
}



// WEBPACK FOOTER //
// ./src/web/home/components/publicationList.js